import React from "react";
import {
  Accordion,
  DoubleContent,
  LinkPrimary,
  SectionContent,
  TextBodyAccordion,
  List,
} from "../../../../components";
import { envs } from "../../../../config";
import DuvidasConsorcioHeadline from "./EntendaMais.Style";
import { diferencaSorteioLance } from "../../data";

const duvidasConsorcioList = [
  {
    title: "Como funciona o consórcio?",
    body: (
      <TextBodyAccordion>
        Quer conquistar uma casa ou carro e precisa de uma força para assumir
        esse compromisso? Então, conte com a gente e com o nosso consórcio. Ele
        funciona como uma modalidade de compra coletiva, onde um grupo de
        pessoas se compromete a pagar uma parcela mensal, por um tempo
        determinado. Esse dinheiro é guardado num fundo comum e, todo mês,
        alguns integrantes do grupo são escolhidos (por sorteio e lance) para
        receber o valor do crédito e comprar o bem.
      </TextBodyAccordion>
    ),
  },
  {
    title: "Quais são os valores das parcelas?",
    body: (
      <TextBodyAccordion>
        Você pode planejar suas conquistas com parcelas que cabem no seu bolso.
        O <strong>Consórcio Imobiliário</strong> tem parcelas mensais a partir
        de R$ 427,00 e prazo de 200 meses e o{" "}
        <strong>Consórcio de Veículos</strong> possui parcelas a partir de R$
        367,03 e prazo de 80 meses.
      </TextBodyAccordion>
    ),
  },
  {
    title: "O que é cobrado na parcela do meu consórcio?",
    body: (
      <>
        <TextBodyAccordion>
          No consórcio você não paga juros. Veja para que o seu dinheiro será
          destinado:
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong>Fundo Comum:</strong> é o valor que será reunido para a compra
          do bem. É desse fundo que tiramos o crédito que será destinado aos
          contemplados e, havendo saldo no encerramento do grupo, será devolvido
          aos consorciados ativos e cancelados.
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong>Fundo de Reserva:</strong> esse fundo é essencial para manter
          a saúde financeira do grupo. O valor é destinado a uma reserva em
          casos de imprevistos como cobrir uma eventual falta de dinheiro no
          Fundo Comum e, havendo saldo no encerramento do grupo, o mesmo será
          devolvido aos consorciados ativos.
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong>Taxa de Administração:</strong> é o valor que a gente cobra
          para administrar seu consórcio. A Taxa de Administração é diferente
          dos juros cobrados em outras modalidades, por isso é bem menor. Ela é
          dividida durante o tempo contratado: um pedacinho em cada parcela.
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong>Seguro Prestamista:</strong> esse seguro é opcional e cobrado
          a partir da 2ª parcela. Em caso de morte ou invalidez total e
          permanente do consorciado, o seguro quita o saldo devedor do seu
          consórcio. Trata-se de uma escolha importante para quem quer cuidar da
          família.
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong>Seguro Danos Físicos ao Imóvel (DFI):</strong> exclusivo para
          o Consórcio Imobiliário, esse seguro é cobrado somente após a
          aquisição, construção, reforma e/ou ampliação do imóvel.
        </TextBodyAccordion>
      </>
    ),
  },
  {
    title: "Como é atualizado o valor do meu crédito?",
    body: (
      <TextBodyAccordion>
        O valor do crédito é corrigido de acordo com o Índice Nacional de Preços
        ao Consumidor - INPC. A cada 12 assembleias do grupo, o crédito é
        atualizado com ajuste da parcela e do saldo devedor. Assim, seu poder de
        compra é mantido.
      </TextBodyAccordion>
    ),
  },
  { ...diferencaSorteioLance },
  {
    title: "Como usar o meu FGTS no Consórcio Imobiliário?",
    body: (
      <>
        <TextBodyAccordion>
          Existem algumas opções para usar o Fundo de Garantia do Tempo de
          Serviço (FGTS) no seu Consórcio Imobiliário, de acordo com as regras
          do próprio fundo. São elas:
        </TextBodyAccordion>
        <List styleType="disc">
          <li>
            <TextBodyAccordion as="span">
              Complementar o pagamento do valor do imóvel a ser adquirido;
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion as="span">
              Pagar parte das parcelas do seu consórcio e também amortizar; ou
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion>
              Quitar o saldo devedor após a aquisição do imóvel.
            </TextBodyAccordion>
          </li>
        </List>
        <TextBodyAccordion>
          Para saber mais,{" "}
          <LinkPrimary
            target="_blank"
            href={`${envs.hostStaticCdn}/AreaAberta/Consorcio/Cartilhas/CARTILHA-FGTS.pdf`}
          >
            consulte aqui a cartilha
          </LinkPrimary>{" "}
          para o uso do FGTS
        </TextBodyAccordion>
      </>
    ),
  },
];

const EntendaMais = () => {
  return (
    <>
      <SectionContent>
        <DoubleContent
          leftContent={
            <DuvidasConsorcioHeadline nivel="2" styleAs="5">
              Tire suas dúvidas sobre o consórcio
            </DuvidasConsorcioHeadline>
          }
          rightContent={<Accordion listItems={duvidasConsorcioList} />}
        />
      </SectionContent>
    </>
  );
};

export default EntendaMais;
